module.exports = __webpack_public_path__ + "img/MASTER_CHN_VP_Handbook_Web10.2de847dd.jpg";